module.exports = __webpack_public_path__ + "static/media/om_faceshape_square.7453c342.png";